module.exports = __webpack_public_path__ + "posture/static/img/head_sideway_left.4c5ece5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/head_sideway_left.png
// module id = Mks9
// module chunks = 1